export default __webpack_public_path__ + "static/media/easy-installation-5Gi.2be9dd22.svg";